'use strict';

const modal = document.getElementById('modal-image-viewer');
const modalImg = document.getElementById('modal-image');
const closeBtn = modal.querySelector('.modal-close');
const prevBtn = modal.querySelector('.modal-prev');
const nextBtn = modal.querySelector('.modal-next');
const modalCaption = modal.querySelector('.modal-caption');

//const galleryItems = Array.from(document.querySelectorAll('.galleryItem'));

const allGalleryItems = Array.from(document.querySelectorAll('.galleryItem'));

const uniqueHrefSet = new Set();
const galleryItems = [];

allGalleryItems.forEach(item => {
  const href = item.getAttribute('href');
  if (!uniqueHrefSet.has(href)) {
    uniqueHrefSet.add(href);
    galleryItems.push(item);
  }
});


let currentIndex = 0;

function showModal(index) {
    currentIndex = index;
    const item = galleryItems[currentIndex];
    modalImg.src = item.getAttribute('href');

    // Проверяем, есть ли тег img
    const imgTag = item.querySelector('img');
    modalImg.alt = imgTag ? imgTag.alt : '';

    modalCaption.textContent = item.getAttribute('aria-label') || '';

    modal.classList.remove('hide');
    document.body.style.overflow = 'hidden';
}

function hideModal() {
    modal.classList.add('hide');
    document.body.style.overflow = ''; // вернуть скролл страницы
}

function showNext() {
    currentIndex = (currentIndex + 1) % galleryItems.length;
    showModal(currentIndex);
}

function showPrev() {
    currentIndex = (currentIndex - 1 + galleryItems.length) % galleryItems.length;
    showModal(currentIndex);
}

// Привязка событий к items
galleryItems.forEach((el, i) => {
    el.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();
        showModal(i);
    }, { passive: false });
});

closeBtn.addEventListener('click', e => {
    e.preventDefault();
    hideModal();
});

modal.addEventListener('click', e => {
    if(e.target === modal) {
        hideModal();
    }
});

// Стрелки вперед/назад
nextBtn.addEventListener('click', e => {
    e.stopPropagation();
    showNext();
});

prevBtn.addEventListener('click', e => {
    e.stopPropagation();
    showPrev();
});

// Обработка нажатия стрелок клавиатуры
window.addEventListener('keydown', e => {
    if (modal.classList.contains('hide')) return;

    if (e.key === 'ArrowRight') {
        showNext();
    } else if (e.key === 'ArrowLeft') {
        showPrev();
    } else if (e.key === 'Escape') {
        hideModal();
    }
});


let touchStartX = 0;
let touchEndX = 0;

modal.addEventListener('touchstart', e => {
    touchStartX = e.changedTouches[0].screenX;
}, { passive: true });

modal.addEventListener('touchend', e => {
    touchEndX = e.changedTouches[0].screenX;
    handleSwipeGesture();
}, { passive: true });

function handleSwipeGesture() {
    const swipeThreshold = 50; // минимальная дистанция свайпа в пикселях
    const deltaX = touchEndX - touchStartX;

    if (Math.abs(deltaX) > swipeThreshold) {
        if (deltaX > 0) {
            // свайп вправо
            showPrev();
        } else {
            // свайп влево
            showNext();
        }
    }
}
